import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";

import TextField from "@material-ui/core/TextField";

import { Checkbox } from "@material-ui/core";
import InputSelect from "../../common/InputSelect";

export default function ProfileInfo(props) {
  //const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    label: {
      fontSize: 12,
      margin: 0,
    },
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "100%",
      "& .MuiTextField-root": {
        width: "100%",
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
    centerFS: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "100%",
      "& .MuiTextField-root": {
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  const [profiles, setProfiles] = useState();
  useEffect(() => {
    const url = process.env.REACT_APP_API2_URL + "/Player/GetPlayerProfile";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let profilesInfo = data.map((v) => {
          v.IdLineType = v.idProfile;
          v.Description = v.profileName;
          return v;
        });
        setProfiles(profilesInfo);
      });
  }, []);

  const handleUpdate = (event, key, value) => {
    props.Profile[key] = event ? event.target.value : value;
    props.UpdateProfile(props.Profile);
  };

  const [localProfile, setLocalProfile] = useState(props.Profile);
  const handleChange = (event, key, value) => {
    setLocalProfile({
      ...localProfile,
      [key]: event ? event.target.value : value,
    });
  };

  useEffect(() => {
    setLocalProfile(props.Profile);
  }, [props.Profile, setLocalProfile]);

  return (
    <React.Fragment>
      <br />
      <h2 className="w-full text-center">{props.Profile.profileName}</h2>
      {props.Profile && (
        <form className={`${classes.center} grid grid-cols-2 w-full gap-4`}>
          <div className="vertical-options">
            <TextField
              className="w-full"
              size="small"
              type="text"
              label="Name"
              value={localProfile.profileName}
              multiline={false}
              onChange={(event) => handleChange(event, "profileName")}
              onBlur={(event) => handleUpdate(event, "profileName")}
              variant="outlined"
            />
            <div className="flex flex-row gap-4">
              <Checkbox
                className="w-auto"
                size="small"
                checked={localProfile.alternateEnable}
                onChange={(event) => {
                  handleChange(
                    undefined,
                    "alternateEnable",
                    event.target.checked
                  );
                  handleUpdate(
                    undefined,
                    "alternateEnable",
                    event.target.checked
                  );
                }}
                color="primary"
              />
              <InputSelect
                variant="outlined"
                size="small"
                label="Alternate"
                name="name"
                data={profiles}
                placeholder="Alternate"
                setSelectValue={(value) =>
                  handleChange(undefined, "alternateProfile", value)
                }
                startValue={localProfile.alternateProfile}
              />
            </div>
          </div>
          <div className="vertical-options">
            <TextField
              className="flex-1"
              size="small"
              type="text"
              label="Notes"
              value={localProfile.notes}
              onChange={(event) => handleChange(event, "notes")}
              onBlur={(event) => handleUpdate(event, "notes")}
              variant="outlined"
              multiline
              minRows={4}
            />
          </div>
        </form>
      )}
    </React.Fragment>
  );
}
